import { render } from "./CrmBottomNavigation.vue?vue&type=template&id=ea541346&scoped=true"
import script from "./CrmBottomNavigation.vue?vue&type=script&lang=js"
export * from "./CrmBottomNavigation.vue?vue&type=script&lang=js"

import "./CrmBottomNavigation.vue?vue&type=style&index=0&id=ea541346&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea541346"]])

export default __exports__